import { IActionsSetCurrentTab } from "../actions/documentScreen";

export const setCurrentTab = (index: number): IActionsSetCurrentTab => {
  return {
    type: "SET_CURRENT_TAB",
    index: index,
  };
};
